import { Divider, toReactNode } from '@pique/component';
import { motion } from 'framer-motion';
import { html } from 'lit';
import { useCallback, useEffect, useRef, useState } from 'react';

import * as styles from './lecture-scorecard.css';

const icons = {
  zap: () => html`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="16"
      height="16"
      fill="none"
    >
      <path
        d="M8.62814 12.6736H8.16918C6.68545 12.6736 5.94358 12.6736 5.62736 12.1844C5.31114 11.6953 5.61244 11.0138 6.21504 9.65083L8.02668 5.55323C8.57457 4.314 8.84852 3.69438 9.37997 3.34719C9.91142 3 10.5859 3 11.935 3H14.0244C15.6632 3 16.4826 3 16.7916 3.53535C17.1007 4.0707 16.6942 4.78588 15.8811 6.21623L14.8092 8.10188C14.405 8.81295 14.2029 9.16849 14.2057 9.45952C14.2094 9.83775 14.4105 10.1862 14.7354 10.377C14.9854 10.5239 15.3927 10.5239 16.2074 10.5239C17.2373 10.5239 17.7523 10.5239 18.0205 10.7022C18.3689 10.9338 18.5513 11.3482 18.4874 11.7632C18.4382 12.0826 18.0918 12.4656 17.399 13.2317L11.8639 19.3523C10.7767 20.5545 10.2331 21.1556 9.86807 20.9654C9.50303 20.7751 9.67833 19.9822 10.0289 18.3962L10.7157 15.2896C10.9826 14.082 11.1161 13.4782 10.7951 13.0759C10.4741 12.6736 9.85877 12.6736 8.62814 12.6736Z"
        stroke="#FFD700"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
    </svg>
  `,
  brain: () => html`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="16"
      height="16"
      fill="none"
    >
      <path
        d="M7 4.5C5.34315 4.5 4 5.84315 4 7.5C4 8.06866 4.15822 8.60037 4.43304 9.0535C3.04727 9.31855 2 10.537 2 12C2 13.463 3.04727 14.6814 4.43304 14.9465M7 4.5C7 3.11929 8.11929 2 9.5 2C10.8807 2 12 3.11929 12 4.5V19.5C12 20.8807 10.8807 22 9.5 22C8.11929 22 7 20.8807 7 19.5C5.34315 19.5 4 18.1569 4 16.5C4 15.9313 4.15822 15.3996 4.43304 14.9465M7 4.5C7 5.31791 7.39278 6.04408 8 6.50018M4.43304 14.9465C4.78948 14.3588 5.34207 13.9032 6 13.6707"
        stroke="#4ADE80"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17 19.4999C18.6569 19.4999 20 18.1567 20 16.4999C20 15.9312 19.8418 15.3995 19.567 14.9464C20.9527 14.6813 22 13.4629 22 11.9999C22 10.5369 20.9527 9.31843 19.567 9.05338M17 19.4999C17 20.8806 15.8807 21.9999 14.5 21.9999C13.1193 21.9999 12 20.8806 12 19.4999L12 4.49988C12 3.11917 13.1193 1.99988 14.5 1.99988C15.8807 1.99988 17 3.11917 17 4.49988C18.6569 4.49988 20 5.84302 20 7.49988C20 8.06854 19.8418 8.60024 19.567 9.05338M17 19.4999C17 18.682 16.6072 17.9558 16 17.4997M19.567 9.05338C19.2105 9.64109 18.6579 10.0966 18 10.3292"
        stroke="#4ADE80"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `,
  star: () => html`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="16"
      height="16"
      fill="none"
    >
      <path
        d="M13.7276 3.44418L15.4874 6.99288C15.7274 7.48687 16.3673 7.9607 16.9073 8.05143L20.0969 8.58575C22.1367 8.92853 22.6167 10.4206 21.1468 11.8925L18.6671 14.3927C18.2471 14.8161 18.0172 15.6327 18.1471 16.2175L18.8571 19.3125C19.417 21.7623 18.1271 22.71 15.9774 21.4296L12.9877 19.6452C12.4478 19.3226 11.5579 19.3226 11.0079 19.6452L8.01827 21.4296C5.8785 22.71 4.57865 21.7522 5.13859 19.3125L5.84851 16.2175C5.97849 15.6327 5.74852 14.8161 5.32856 14.3927L2.84884 11.8925C1.389 10.4206 1.85895 8.92853 3.89872 8.58575L7.08837 8.05143C7.61831 7.9607 8.25824 7.48687 8.49821 6.99288L10.258 3.44418C11.2179 1.51861 12.7777 1.51861 13.7276 3.44418Z"
        stroke="#FFD700"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `,
  question: () => html`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="16"
      height="16"
      fill="none"
    >
      <circle cx="12" cy="12" r="10" stroke="#60A5FA" stroke-width="1.5" />
      <path
        d="M10 9C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9C14 9.39815 13.8837 9.76913 13.6831 10.0808C13.0854 11.0097 12 11.8954 12 13V13.5"
        stroke="#60A5FA"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M11.992 17H12.001"
        stroke="#60A5FA"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `,
  time: () => html`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="16"
      height="16"
      fill="none"
    >
      <path
        d="M2 22H13C17.9706 22 22 17.9706 22 13C22 8.02944 17.9706 4 13 4C8.36745 4 4.49744 7.50005 4 12"
        stroke="#ffffff"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M18.5 5.5L19.5 4.5M5.5 4.5L6.5 5.5"
        stroke="#ffffff"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.5001 9.00003L13.5608 11.9394M13.5608 11.9394C13.2893 11.6679 12.9143 11.5 12.5001 11.5C11.6717 11.5 11.0001 12.1716 11.0001 13C11.0001 13.8285 11.6717 14.5 12.5001 14.5C13.3285 14.5 14.0001 13.8285 14.0001 13C14.0001 12.5858 13.8322 12.2108 13.5608 11.9394Z"
        stroke="#ffffff"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M12.5 3.5V2M10.5 2H14.5M2 15H5M2 19H7"
        stroke="#ffffff"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `,
};

// Create React components from Lit templates
const Icon = ({ template }: { template: () => ReturnType<typeof html> }) => {
  return toReactNode(template());
};

const stats = [
  { icon: icons.brain, value: '7/10', label: 'Key Points' },
  // { icon: icons.zap, value: '1265', label: 'XP Gained' },
  { icon: icons.star, value: '17', label: 'Stars' },
  { icon: icons.question, value: '3', label: 'Questions' },
  { icon: icons.time, value: '1:22', label: 'Time Spent' },
];

const LectureScorecard = () => {
  const [isLoading, setIsLoading] = useState(false);
  const emitTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const lastEmitTimeRef = useRef<number>(0);
  const DEBOUNCE_DELAY = 10000; // 10 seconds debounce

  const containerVariants = {
    hidden: {
      y: 100,
      opacity: 0,
      scale: 0.5,
      rotate: -15,
    },
    visible: {
      y: 0,
      opacity: 1,
      scale: 1,
      rotate: 0,
      transition: {
        type: 'spring',
        damping: 12,
        stiffness: 150,
        mass: 0.8,
        duration: 0.8,
        delayChildren: 0.2,
        staggerChildren: 0.08,
      },
    },
  };

  const contentVariants = {
    hidden: {
      scale: 0.8,
      opacity: 0,
      y: 30,
      rotate: -5,
    },
    visible: {
      scale: 1,
      opacity: 1,
      y: 0,
      rotate: 0,
      transition: {
        type: 'spring',
        damping: 15,
        stiffness: 200,
        duration: 0.5,
      },
    },
  };

  const statItemVariants = {
    hidden: {
      scale: 0,
      opacity: 0,
      rotate: -25,
      y: 20,
    },
    visible: {
      scale: 1,
      opacity: 1,
      rotate: 0,
      y: 0,
      transition: {
        type: 'spring',
        damping: 8,
        stiffness: 150,
        mass: 0.6,
        duration: 0.5,
        bounce: 0.5,
      },
    },
  };

  const handleViewNotes = useCallback(() => {
    const now = Date.now();
    if (now - lastEmitTimeRef.current < DEBOUNCE_DELAY) {
      // If not enough time has passed since last emit, just return
      return;
    }

    setIsLoading(true);
    lastEmitTimeRef.current = now;

    // Clear any existing timeout
    if (emitTimeoutRef.current) {
      clearTimeout(emitTimeoutRef.current);
    }

    // Set new timeout for emission
    emitTimeoutRef.current = setTimeout(() => {
      // Keep showing loading state for a while after emission
      setTimeout(() => {
        setIsLoading(false);
      }, 5000);
    }, 5000);
  }, []);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (emitTimeoutRef.current) {
        clearTimeout(emitTimeoutRef.current);
      }
    };
  }, []);

  return (
    <motion.div
      className={styles.container}
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <motion.div className={styles.card} variants={contentVariants}>
        <div className={styles.content}>
          <motion.div className={styles.header} variants={contentVariants}>
            <div className={styles.headerLeft}>
              <motion.div
                className={styles.iconWrapper}
                whileHover={{ scale: 1.1, rotate: 15 }}
                transition={{ type: 'spring', stiffness: 400, damping: 10 }}
              >
                <Icon template={icons.zap} />
              </motion.div>
              <div>
                <motion.h2 className={styles.title} variants={contentVariants}>
                  Lecture Complete!
                </motion.h2>
                <motion.p
                  className={styles.subtitle}
                  variants={contentVariants}
                >
                  Great job on finishing the lecture!
                </motion.p>
              </div>
            </div>
            <motion.button
              className={styles.viewNotesButton}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              variants={contentVariants}
              onClick={handleViewNotes}
              disabled={isLoading}
              data-loading={isLoading}
            >
              {isLoading ? 'Pique is working...' : 'View AI Notes'}
            </motion.button>
          </motion.div>
          <Divider />
          <div className={styles.statsGrid}>
            {stats.map((stat, index) => (
              <motion.div
                key={index}
                className={styles.statItem}
                variants={statItemVariants}
                whileHover={{
                  scale: 1.05,
                  transition: { type: 'spring', stiffness: 400, damping: 10 },
                }}
              >
                <div className={styles.statValue}>
                  <Icon template={stat.icon} />
                  <span>{stat.value}</span>
                </div>
                <span className={styles.statLabel}>{stat.label}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default LectureScorecard;
